(function ($) {
    $(function () {
        if ($('.content__wrap')) {
            $('[data-toggle="tooltip"]').tooltip()
        }
    });
})(jQuery);